// src/components/StudioSearchForm.js
import React, { useState } from 'react';
import './StudioSearchForm.css';

export default function StudioSearchForm({ onSearch }) {
  const [city, setCity] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ city });
  };

  return (
    <form className="studio-search-form" onSubmit={handleSubmit}>
      <select value={city} onChange={(e) => setCity(e.target.value)}>
        <option value="">Toutes les villes</option>
        <option value="Marrakech">Marrakech</option>
        <option value="Rabat">Rabat</option>
        <option value="Casablanca">Casablanca</option>
        <option value="Tanger">Tanger</option>
        <option value="Benguerir">Benguerir</option>
      </select>

      <button type="submit">Rechercher</button>
    </form>
  );
}
